import { ref, toValue, watchEffect, type MaybeRefOrGetter } from "vue";

const analyticsPageTitle = ref<string | null>(null);

export const useAnalyticsPageTitleState = () => analyticsPageTitle;

export function useAnalyticsPageTitle(title: MaybeRefOrGetter<string | null | undefined>) {
  watchEffect(() => {
    analyticsPageTitle.value = toValue(title) ?? null;
  });
}
